import {
  Edit,
  SimpleForm,
  TextInput,
  AutocompleteArrayInput,
  useNotify,
  useRedirect,
} from "react-admin";
import { useEffect, useState } from "react";
import { apiUrl } from "../../apiendpoint";

export const RolePermissionEdit = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("access_token");

    if (!token) {
      notify("Not authenticated", { type: "warning" });
      return;
    }

    fetch(`${apiUrl}permissions/all`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((data) => {
        setPermissions(
          data.map((p) => ({
            id: p.id,
            name: p.name,
          }))
        );
      })
      .catch(() =>
        notify("Failed to load permissions", { type: "error" })
      );
  }, [notify]);
const transform = (data) => ({
  ...data,
  permission_ids: data.permission_ids || [],
});
  return (
<Edit
  title="Edit Role Permissions"
  {...props}
  transform={transform}
  redirect="list"   // ✅ IMPORTANT
>
  <SimpleForm
    onSuccess={() =>
      notify("Role permissions updated successfully", {
        type: "success",
      })
    }
  >
    <TextInput source="role_name" disabled fullWidth />

    <AutocompleteArrayInput
      source="permission_ids"
      choices={permissions}
      optionText="name"
      optionValue="id"
      fullWidth
      format={(value) => value || []}
      parse={(value) => value || []}
    />
  </SimpleForm>
</Edit>
  );
};